export default "__VITE_ASSET__CN3pjjKc__"